module.exports = __webpack_public_path__ + "img/1.3f2729a4.png";